<template>
    <LoadingDiv v-if="isLoading" />

    <template v-else>

        <template v-if="complete">
            <div class="section">
                <div class="card grey lighten-4">
                    <!-- Heading -->
                    <div class="card-content">
                        <span class="card-title teal-text">
                            {{ oneProvider?.name }} <i class="material-icons">check_circle</i>
                        </span>
                        <span class="chip teal lighten-2" v-if="tariffStatus">Tariff has been updated!</span>
                    </div>
                </div>
            </div>

            <!-- Replace -->
            <AddTariff :providerId="provider?.id" :planId="planId" @reload="handleReload" />
        </template>

        <template v-else>
            <div class="section">
                <div class="card grey lighten-4">
                    <!-- Heading -->
                    <div class="card-content">
                        <span class="card-title teal-text">
                            {{ oneProvider?.name }}
                        </span>
                    </div>

                    <!-- Section 1 -->
                    <!-- Name -->
                    <div class="card-panel teal-text">
                        <div class="row">
                            <div class="col s12">
                                <span class="black-text pointable" title="required section"><i
                                        class="tiny material-icons orange-text">star</i>Provider <em>Name</em></span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col s12">
                                <div class="input-field">
                                    <input type="text" id="name" :value="oneProvider?.name" disabled />
                                    <label class="active" for="name">Registered As</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Section 2 -->
                    <!-- Sync -->
                    <div class="card-panel teal-text">
                        <div class="row">
                            <div class="col s12">
                                <span class="black-text pointable" title="required section"><i
                                        class="tiny material-icons orange-text">star</i>Provider <em>Sync</em></span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col s12">
                                <span class="chip red white-text" v-if="!similarProviders.length">
                                    No Matching Record in the Database!
                                    <br /><br />
                                </span>

                                <label v-for="similar in similarProviders" :key="similar.id">
                                    <input type="radio" class="with-gap" id="provider" :value="similar"
                                        v-model="provider"
                                        @click="allPlans.find(x => x.id === similar?.plan_id) ? planId = String(similar?.plan_id) : planId = null" />
                                    <span class="grey-text text-darken-2">Sync <em>as</em> {{ similar.name }}
                                        <i class="tiny material-icons" v-if="provider === similar">check_circle</i>
                                    </span>
                                    <br />
                                    <br v-if="similar.score > 78" />
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Section 3 -->
                    <!-- Tariff -->
                    <div class="card-panel teal-text">
                        <div class="row">
                            <div class="col s12">
                                <span class="black-text pointable" title="required section"><i
                                        class="tiny material-icons orange-text">star</i>Provider <em>Tariff</em></span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field col s12">
                                <select v-model="planId">
                                    <option value="" disabled selected>Select HMO Plan</option>
                                    <option v-for="providerPlan in allPlans" :key="providerPlan.id"
                                        :value="providerPlan.id">
                                        {{ providerPlan.name }}
                                    </option>
                                </select>
                                <label>Type of Plan (Enrollees)</label>
                            </div>

                        </div>
                    </div>

                    <!-- Section 4 -->
                    <!-- Schemes -->
                    <div class="card-panel teal-text">
                        <div class="row">
                            <div class="col s12">
                                <span class="black-text pointable" title="required section"><i
                                        class="tiny material-icons orange-text">star</i>Provider <em>Schemes</em></span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col s12">
                                <label v-for="scheme in allSchemes" :key="scheme.id">
                                    <input type="checkbox" class="filled-in" id="schemes" :value="scheme.id"
                                        v-model="schemes" />
                                    <span class="grey-text text-darken-2">{{ scheme.name }}</span> <span>({{
                                        scheme.type === 'p' ? 'Private Scheme' : 'Social Scheme'
                                        }})</span>
                                    <br />
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Section 5 -->
                    <!-- List -->
                    <div class="card-panel grey lighten-5 teal-text">
                        <div class="row">
                            <div class="col s12">
                                <span class="black-text pointable" title="required section"><i
                                        class="tiny material-icons orange-text">star</i>Enrollee List <em>Mandate</em></span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col s12">
                                <label v-for="list in schemes" :key="list">
                                    <input type="checkbox" class="filled-in" id="lists" :value="list" v-model="lists" />
                                    <span class="grey-text text-darken-2">{{allSchemes.find(x => x.id === list)?.name
                                        }}</span> <span class="grey-text text-darken-2" v-if="lists.find(x => x === list)"><i>(enrollee <b>list</b> required)</i></span>
                                    <br />
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Section 6 -->
                    <!-- Vet -->
                    <div class="card-panel grey lighten-5 teal-text">
                        <div class="row">
                            <div class="col s12">
                                <span class="black-text pointable" title="required section"><i
                                        class="tiny material-icons orange-text">star</i>Claims Vetting <em>Mandate</em></span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col s12">
                                <label v-for="vet in schemes" :key="vet">
                                    <input type="checkbox" class="filled-in" id="vettings" :value="vet" v-model="vettings" />
                                    <span class="grey-text text-darken-2">{{allSchemes.find(x => x.id === vet)?.name
                                        }}</span> <span class="grey-text text-darken-2" v-if="vettings.find(x => x === vet)"><i>(vet in <b>this workspace</b>)</i></span><span class="grey-text text-darken-2" v-else><i>(late sync after <b>oneProvider</b> vetting)</i></span>
                                    <br />
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Sumbmitting -->
                    <div class="progress" v-if="isSubmitting">
                        <div class="indeterminate"></div>
                    </div>

                </div>
            </div>

            <div class="section right">
                <p>
                    <a class="waves-effect waves-light btn-large grey" :class="{
                        disabled: isSubmitting,
                    }" @click.prevent="handleBack">
                        <i class="material-icons left">chevron_left</i>Back
                    </a>
                    <button class="waves-effect waves-light btn-large black" :class="{
                        disabled: isSubmitting || !provider || !planId || !schemes.length
                    }" @click="handleSync">
                        <i class="material-icons right">check_circle</i>
                        {{ isSubmitting ? "Syncing..." : "Sync" }}
                    </button>
                </p>
            </div>
        </template>

    </template>
</template>

<script>
import { ref, computed, onMounted, onUpdated, watch } from "vue";
import getItems from "@/composables/getItems";
import putItem from "@/composables/putItem";
import AddTariff from "@/components/tariff/AddTariffComponent.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import { OPID } from '@/laravel/config';
import nativeUi from "@/ui/native-ui";

export default {
    name: "SyncProviderComponent",
    components: { AddTariff, LoadingDiv },
    props: ["oneProvider"],
    emits: ["clear", "update"],
    setup(props, context) {
        const complete = ref(props.oneProvider.pivot.status === 'a' ? true : false);
        const tariffStatus = ref(false);
        const response = ref(null);
        const responsePlans = ref(null);
        const responseSchemes = ref(null);
        const responseProviders = ref(null);
        const isReady = ref(true);
        const isLoading = ref(0);
        const isSubmitting = ref(false);
        const schemes = ref([]);
        const lists = ref([]);
        const vettings = ref([]);
        const provider = ref(null); // from easyHMO
        const planId = ref(null);
        const error = ref(null);


        // select dropdown
        onMounted(() => {
            // activate select field
            const elemsSelect = document.querySelectorAll("select");
            nativeUi.FormSelect.init(elemsSelect, {});
        });

        // select dropdown
        onUpdated(() => {
            // activate select field
            const elemsSelect = document.querySelectorAll("select");
            nativeUi.FormSelect.init(elemsSelect, {});
        });

        // starter
        onMounted(() => {
            // get plans
            getItemsFromApi("plan/private", "plans"); isLoading.value++;
            // get schemes
            getItemsFromApi("scheme", "schemes"); isLoading.value++;
            // get similar providers
            getItemsFromApi(`provider/match?q=${props.oneProvider.name}`, "providers"); isLoading.value++;
        });

        // get function
        const getItemsFromApi = (table, type) => {

            (async () => {
                const { res, err } = await getItems(table);

                if (res.value) {
                    if (type === "plans") {
                        responsePlans.value = res.value.data;
                    } else if (type == "schemes") {
                        responseSchemes.value = res.value.data;
                    } else if (type == "providers") {
                        responseProviders.value = res.value.data;
                    }
                } else {
                    error.value = err.value;
                }

                // page is ready
                isLoading.value--;
            })();
        };

        const handleReload = (val) => {
            if (val) {
                // final
                tariffStatus.value = true;
            }
        };

        // Back
        const handleBack = () => {
            // clear
            context.emit("clear", true);
        }

        // Sync
        const handleSync = async () => {

            // start
            isSubmitting.value = true;

            // Manual Claims
            const manual_claims = schemes.value.filter(s => !lists.value.includes(s));

            // Vettings
            const late_sync_claims = schemes.value.filter(s => !vettings.value.includes(s));

            // update
            let newVal = {
                oneprovider: {
                    status: "a",
                    schemes: schemes.value,
                    claims: manual_claims.length ? manual_claims : [],
                    sync: late_sync_claims.length ? late_sync_claims : [],
                    payer_opid: OPID,
                    provider_id: props.oneProvider.id,
                },
                easyhmo: {
                    opid: props.oneProvider.opid,
                    md: props.oneProvider.md,
                    name: props.oneProvider.name,
                    address: props.oneProvider.address,
                    state: props.oneProvider.state,
                    country: props.oneProvider.country,
                    // geolocation: props.oneProvider.geolocation,
                    phone: props.oneProvider.phone,
                    email: props.oneProvider.email,
                    admin: props.oneProvider.admin,
                    admin_phone: props.oneProvider.admin_phone,
                    stores: {
                          md: provider.value?.md,
                          name: provider.value?.name,
                          address: provider.value?.address,
                          state: provider.value?.state,
                          country: provider.value?.country,
                          geolocation: provider.value?.geolocation,
                          phone: provider.value?.phone,
                          email: provider.value?.email,
                          admin: provider.value?.admin,
                          admin_phone: provider.value?.admin_phone,
                    },
                    schedule_id: null, // get from plan
                    plan_id: planId.value,
                }
            };


            // post item
            const { res, err } = await putItem("provider/sync", provider.value?.id, newVal);

            if (res.value) {
                // complete
                complete.value = true;
                // update
                context.emit("update", "a");
            } else {
                error.value = err.value;
            }

            // end
            isSubmitting.value = false;
        };


        // watch lists (schemes)
        watch(schemes, (newSchemes, oldSchemes) => {

            // Added items
            const added = newSchemes.filter(n => !oldSchemes.includes(n));
            // Removed items
            const removed = oldSchemes.filter(n => !newSchemes.includes(n));

            // Add newly selected numbers
            added.forEach(n => {
                if (!lists.value.includes(n)) {
                    lists.value.push(n)
                }
            });

            // Remove deselected numbers
            removed.forEach(n => {
                const index = lists.value.indexOf(n)
                if (index !== -1) {
                    lists.value.splice(index, 1)
                }
            });

        })

        // watch vettings (schemes)
        watch(schemes, (newSchemes, oldSchemes) => {

            // Added items
            const added = newSchemes.filter(n => !oldSchemes.includes(n));
            // Removed items
            const removed = oldSchemes.filter(n => !newSchemes.includes(n));

            // Add newly selected numbers
            added.forEach(n => {
                if (!vettings.value.includes(n)) {
                    vettings.value.push(n)
                }
            });

            // Remove deselected numbers
            removed.forEach(n => {
                const index = vettings.value.indexOf(n)
                if (index !== -1) {
                    vettings.value.splice(index, 1)
                }
            });

        })

        // output results
        const allPlans = computed(() => {
            if (!responsePlans.value) {
                return [];
            } else {
                return responsePlans.value;
            }
        });

        // output results
        const allSchemes = computed(() => {
            if (!responseSchemes.value) {
                return [];
            } else {
                return responseSchemes.value;
            }
        });

        // output results
        const similarProviders = computed(() => {
            if (!responseProviders.value) {
                return [];
            } else {
                let highMatch = responseProviders.value.filter(x => x.score > 70);
                return highMatch;
            }
        });

        return {
            handleBack,
            handleSync,
            handleReload,
            isReady,
            response,
            isLoading,
            isSubmitting,
            complete,
            tariffStatus,
            error,
            planId,
            lists,
            vettings,
            allSchemes,
            allPlans,
            similarProviders,
            provider,
            schemes,
        };
    },
};
</script>

<style>
.progress {
    margin-top: -15px;
}

.grey-bg-custom {
    background-color: #f2f2f2;
}

.hover-text {
    cursor: pointer;
}

.clickable {
    cursor: pointer;
}
</style>
